import styled from 'styled-components/macro'

export const Modal = styled.div<{ width?: number }>`
  position: fixed;
  z-index: 102;
  top: 10vh;
  left: 0;
  right: 0;
  margin: auto;
  background: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.border};
  transition: opacity 0.25s ease-in-out;
  color: ${props => props.theme.normalText};

  border-radius: 16px;
  box-shadow: 0 4px 42px ${props => props.theme.shadow};
  overflow: hidden;

  &.closed {
    pointer-events: none;
    opacity: 0;
  }

  @media (max-width: 768px) {
    width: min(1024px, calc(100vw - 32px)) !important;
  }
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px;

  width: 100%;
  background: ${props => props.theme.pageBackground};
`

export const CloseButtonWrapper = styled.div`
  cursor: pointer;
  padding: 15px;
  margin: -15px;

  margin-right: -11px;

  :hover {
    opacity: 0.6;
  }
`

export const ModalContent = styled.div`
  padding: 16px;
  position: relative;
`

export const ModalText = styled.div`
  margin-top: 24px;
  font-size: 16px;
  text-align: center;
  line-height: 22px;
  font-weight: 400;
  word-break: break-word;
`

export const ModalFooter = styled.div`
  border-top: 1px solid ${props => props.theme.border};
  padding: 12px;
  background: ${props => props.theme.pageBackground};
  margin-top: 24px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    margin-top: 0;
  }

  /* Button labels never wrap, so on a phone a long confirm label ("Da, schimbă numele") ran out of the
     dialog. When there are two buttons, tighter pills keep them on one line on most phones; when they still
     do not fit, the confirm button moves above the cancel one instead of overflowing. Its check badge hangs
     10px past the pill (Button's .icon-wrapper), so that room is kept as a margin */
  @media (max-width: 768px) {
    flex-wrap: wrap-reverse;
    gap: 8px;
    padding: 12px 8px;

    button:not(:only-child) {
      padding: 0 16px;
    }

    button:last-child {
      margin-right: 10px;
    }
  }
`
